import { Sigma, LineChart, Layers, ShieldAlert, Binary, FlaskConical } from "lucide-react";
import ProductPageLayout from "@/components/ProductPageLayout";

export default function QuantResearch() {
  return (
    <ProductPageLayout
      meta={{
        title: "Quant Research — Quantitative Derivatives & Options Analytics | Adviserz",
        description:
          "Quantitative research infrastructure: options chain analytics, open interest analytics, volatility analytics and probability & scenario analysis. Informational and analytical only.",
        canonical: "https://adviserz.in/quant-research",
      }}
      overline="Platform · Quant Research"
      title="Quantitative research and"
      accent="derivatives analytics."
      lede="Our quantitative research infrastructure studies market and derivatives data using statistical methods. It covers options chain analytics, volatility behaviour, open interest structure and scenario analysis — presented as analytical research technology, not as trading instructions."
      capabilities={[
        { icon: Layers, t: "Options Chain Analytics", d: "Structural analytics across strikes and expiries — distribution of open interest, premium structure, and changes in the shape of the chain over time." },
        { icon: Sigma, t: "Open Interest Analytics", d: "Measurement of positioning build-up and unwinding, concentration across strikes, and how these statistics have historically been distributed." },
        { icon: LineChart, t: "Volatility Analytics", d: "Implied and realised volatility measurement, term structure, skew analytics and volatility regime classification." },
        { icon: Binary, t: "Probability & Scenario Analysis", d: "Model-based scenario views that describe ranges of statistical outcomes under stated assumptions, with assumptions always disclosed." },
        { icon: FlaskConical, t: "Backtesting Infrastructure", d: "Systematic evaluation of analytical rules on historical data, including handling of look-ahead bias, costs and sample limitations." },
        { icon: ShieldAlert, t: "Risk Analytics", d: "Exposure analytics, sensitivity measurement and drawdown statistics used to describe risk in quantitative terms." },
      ]}
      approach={[
        { t: "Hypothesis", d: "Research begins with a clearly stated, testable question about market behaviour." },
        { t: "Data & features", d: "Relevant datasets are assembled and converted into well-defined quantitative features." },
        { t: "Statistical testing", d: "Relationships are evaluated with statistical methods, including out-of-sample and robustness checks." },
        { t: "Documentation", d: "Findings are documented with methodology, assumptions and limitations — including where results are inconclusive." },
      ]}
      notWhatWeDo={[
        "No \"buy this Call\" or \"buy this Put\" content",
        "No target price or stop-loss levels",
        "No daily derivatives tips or premium calls",
        "No guaranteed or high-accuracy claims",
        "No representation that back-tests predict the future",
        "No personalised derivatives strategy advice",
      ]}
    />
  );
}
